import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';

const BatchHistoryIcon = ({ size, variant, className }: IconProps) => (
  <svg
    className={cn(iconVariant({ variant, size, className }))}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.75 11C8.44036 11 9 10.4404 9 9.75C9 9.05964 8.44036 8.5 7.75 8.5C7.05964 8.5 6.5 9.05964 6.5 9.75C6.5 10.4404 7.05964 11 7.75 11Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75 1H6C7.38071 1 8.5 2.11929 8.5 3.5V4.75C8.5 5.44036 9.05964 6 9.75 6H11C12.3807 6 13.5 7.11929 13.5 8.5V13.75C13.5 14.4404 12.9404 15 12.25 15H3.75C3.05964 15 2.5 14.4404 2.5 13.75V2.25C2.5 1.55964 3.05964 1 3.75 1ZM7.75 12C8.1903 12 8.60106 11.8735 8.94793 11.6549L9.64656 12.3536C9.84182 12.5488 10.1584 12.5488 10.3537 12.3536C10.5489 12.1583 10.5489 11.8417 10.3537 11.6465L9.65502 10.9478C9.87356 10.601 10 10.1902 10 9.75C10 8.50736 8.99264 7.5 7.75 7.5C6.50736 7.5 5.5 8.50736 5.5 9.75C5.5 10.9926 6.50736 12 7.75 12Z"
      fill="currentColor"
    />
    <path
      d="M9.5 3.5C9.5 2.62463 9.17864 1.82432 8.64746 1.2106C10.9134 1.80252 12.6975 3.58658 13.2894 5.85254C12.6757 5.32136 11.8754 5 11 5H9.75C9.61193 5 9.5 4.88807 9.5 4.75V3.5Z"
      fill="currentColor"
    />
  </svg>
);

export default BatchHistoryIcon;
